import type { ApiAgent } from '@/core/entities/api/ApiAgent';
import type { FeatureEnum, PropertyTypeEnum } from '@/core/entities/CRMEnums';
import type { TransactionType } from '@/core/entities/property';

export type ApiPropertyType = Lowercase<keyof typeof PropertyTypeEnum>;

export type ApiTransactionType = 'rent' | 'sell' | 'rent_sell';

export const PropertyPublicationStatus = {
  PUBLISHED: 'published',
  BRAND_UNPUBLISHED: 'brand_unpublished',
  PILAR_UNPUBLISHED: 'pilar_unpublished',
  NEGOTIATED: 'negotiated',
  INACTIVE: 'inactive'
} as const;

export type PropertyPublicationStatusValue = (typeof PropertyPublicationStatus)[keyof typeof PropertyPublicationStatus];

export interface ApiPropertyImage {
  url: string;
  watermarkUrl?: string;
}

export interface ApiAd {
  title: string;
  description: string;
  transactionType: ApiTransactionType;
}

export interface ApiThumbnail {
  thumbnailUrl: string;
  sourceUrl: string;
}

export interface ApiProperty {
  _id: string;
  region: string;
  city: string;
  state: string;
  ad: ApiAd;
  company: {
    id: string;
    name: string;
    smallLogo: string | null;
    largeLogo: string | null;
  };
  companyId: string;
  agent: ApiAgent;
  images: ApiPropertyImage[];
  area: number;
  rentPrice: number | null;
  askingPrice: number | null;
  commercialId: string;
  totalArea: number;
  suites: number;
  bedrooms: number;
  bathrooms: number;
  parkingSpots: number;
  isExclusive: boolean;
  building: string;
  launchDate: string;
  condoName: string;
  tax: number | null;
  condoFee: number | null;
  features: FeatureEnum[];
  thumbnail?: ApiThumbnail;
  propertyType: ApiPropertyType;
  publicationStatus: PropertyPublicationStatusValue;
  slug: string;
  pluscodeGroup: string;
  videos: string[];
}

export type ApiTransactionTypeToDomain = Record<
  ApiTransactionType,
  TransactionType
>;

export const apiTransactionTypeToDomain: ApiTransactionTypeToDomain = {
  rent: 'rent',
  sell: 'sell',
  rent_sell: 'rentOrSell'
};

export interface Ad {
  title: string
  description: string
  transactionType: string
}

export interface Company {
  name: string;
  logo: string;
}

export interface Thumbnail {
  thumbnailUrl: string;
  sourceUrl: string;
}
